module.exports = "pegasus_template/assets/column-17-basic.png";